import type { GrupoEvaluacion } from '@/components/MatrizEvaluacion';

export interface FilterRevisionParams {
  grupos: GrupoEvaluacion[];
  filtroRequisitoId: string;
  filtroRevision: 'TODOS' | 'COMENTARIOS' | 'RECHAZOS';
  requisitosRechazados: Set<string>;
  requisitosComentados: Set<string>;
  ternasRechazadas: Set<string>;
  ternasComentadas: Set<string>;
}

/**
 * Filtra los grupos de evaluación según el requisito específico y/o el estado de revisión.
 */
export function filterGruposRevision({
  grupos,
  filtroRequisitoId,
  filtroRevision,
  requisitosRechazados,
  requisitosComentados,
  ternasRechazadas,
  ternasComentadas,
}: FilterRevisionParams): GrupoEvaluacion[] {
  let result = grupos;

  // 1. Filtrar por requisito específico
  if (filtroRequisitoId) {
    result = result
      .map((grupo) => ({
        ...grupo,
        filas: grupo.filas.filter((fila) => Object.values(fila.celdas).some((req) => req?.id === filtroRequisitoId)),
      }))
      .filter((grupo) => grupo.filas.length > 0);
  }

  // 2. Filtrar por tipo de revisión/correcciones
  if (filtroRevision === 'RECHAZOS') {
    result = result
      .map((grupo) => ({
        ...grupo,
        filas: grupo.filas.filter((fila) => {
          const evalKey = fila.grupo ? `grupo:${fila.grupo}` : fila.ternaId ? `terna:${fila.ternaId}` : null;
          const ternaRechazada = evalKey ? ternasRechazadas.has(evalKey) : false;
          const algunRequisitoRechazado = Object.values(fila.celdas).some((req) => (req ? requisitosRechazados.has(req.id) : false));
          return ternaRechazada || algunRequisitoRechazado;
        }),
      }))
      .filter((grupo) => grupo.filas.length > 0);
  } else if (filtroRevision === 'COMENTARIOS') {
    result = result
      .map((grupo) => ({
        ...grupo,
        filas: grupo.filas.filter((fila) => {
          const evalKey = fila.grupo ? `grupo:${fila.grupo}` : fila.ternaId ? `terna:${fila.ternaId}` : null;
          const ternaComentada = evalKey ? ternasComentadas.has(evalKey) : false;
          const algunRequisitoComentado = Object.values(fila.celdas).some((req) => (req ? requisitosComentados.has(req.id) : false));
          return ternaComentada || algunRequisitoComentado;
        }),
      }))
      .filter((grupo) => grupo.filas.length > 0);
  }

  return result;
}
